import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'chat',
    component: () => import('@/pages/ChatPage.vue'),
    meta: { title: 'Чат', requiresAuth: true },
  },
  {
    path: '/dashboard',
    redirect: { name: 'analytics' },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/pages/AdminPage.vue'),
    meta: { title: 'Админ-панель', requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/support-queue',
    name: 'support-queue',
    component: () => import('@/pages/SupportQueuePage.vue'),
    meta: { title: 'Обращения', requiresAuth: true, requiresManager: true },
  },
  {
    path: '/broadcast',
    name: 'broadcast',
    component: () => import('@/pages/BroadcastPage.vue'),
    meta: { title: 'Рассылки', requiresAuth: true, requiresManager: true },
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('@/pages/AnalyticsPage.vue'),
    meta: { title: 'Аналитика', requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/pages/DocumentsPage.vue'),
    meta: { title: 'Документы', requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/pages/ProfilePage.vue'),
    meta: { title: 'Профиль', requiresAuth: true },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/pages/FaqPage.vue'),
    meta: { title: 'Частые вопросы', requiresAuth: true },
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('@/pages/AnnouncementsPage.vue'),
    meta: { title: 'Объявления', requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { title: 'Вход' },
  },
  {
    path: '/set-password',
    name: 'set-password',
    component: () => import('@/pages/SetPasswordPage.vue'),
    meta: { title: 'Установка пароля', requiresAuth: true },
  },
  {
    path: '/widget/:token',
    name: 'widget',
    component: () => import('@/pages/WidgetChat.vue'),
    meta: { title: 'Виджет чата', requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  document.title = `${to.meta.title || 'Ассистент'} | Ассистент`

  const auth = useAuthStore()

  // Routes that require authentication
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.path } })
  }

  // Routes that require admin role
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return next({ name: 'chat' })
  }

  // Routes that require manager (or higher) role
  if (to.meta.requiresManager && !auth.isManager) {
    return next({ name: 'chat' })
  }

  // Force password setup until the user has set their own password
  if (auth.isAuthenticated && auth.mustSetPassword && to.name !== 'set-password') {
    return next({ name: 'set-password' })
  }

  // If already logged in and trying to access login page — redirect to chat
  if (to.name === 'login' && auth.isAuthenticated) {
    return next({ name: 'chat' })
  }

  next()
})

export default router
